module.exports = __webpack_public_path__ + "img/BOWTIE 2 BW.69c534f.svg";